// src/components/footer/Footer.js — UPDATED WITH ROYAL GREEN GLASS THEME
import React from "react";
import "./Footer.css";

export default function Footer() {
    return (
        <footer className="glass-footer">
            <div className="text-center">
                <div className="footer-content">
                    <p className="footer-text mb-1">
                        © {new Date().getFullYear()}{" "}
                        <strong className="footer-brand">Uttam Kirana</strong>. All rights reserved.
                    </p>
                    <p className="footer-text mb-0">
                        Built with <span>❤️</span> by <strong>Engineerg.com</strong> &nbsp;|&nbsp;
                        Contact: <a href="tel:9826219310" className="footer-link">9826219310</a>
                    </p>
                </div>
            </div>
        </footer>
    );
}